module.exports = __webpack_public_path__ + "static/media/form.81386e64.svg";